import React from "react";
import { FormattedMessage, useIntl } from "react-intl";
import Grid from "@material-ui/core/Grid";
import { Card } from "../../common/card/card";
import { Caption, CardTitle } from "../../admin/workOrderDetails";
import { useWorkOrderStyles } from "./workOrderStyles";
import ActivityQuestionMapper from "../../admin/ActivityQuestionMapper";

const WorkOrderActivity = ({ count, WorkActivitydetails }) => {
    const classes = useWorkOrderStyles();
    const intl = useIntl();

    let activityHeader = "";
    if (intl.locale == "en") {
        switch (WorkActivitydetails?.activity_Id) {
            case 296:
                activityHeader = "Buried Service Wire";
                break;
            case 299:
                activityHeader = "Place Cable - Buried (Bell cable tech use only)";
                break;
            default:
                activityHeader = WorkActivitydetails?.activityNameEn;
        }
    } else {
        switch (WorkActivitydetails?.activity_Id) {
            case 296:
                activityHeader = "Fils de Service Enfoui";
                break;
            case 299:
                activityHeader = "Placer le câble - Enfouis (Réservé aux techniciens des câbles Bell)";
                break;
            default:
                activityHeader = WorkActivitydetails?.activityNameFr;
        }
    }
    return (
        <Card>
            <Grid container className={classes.row}>
                <Grid item xs={9}>
                    <Caption>
                        <FormattedMessage id="admin.work-order-details.wo-info.work-activity-caption" />
                        {" " + count + ": "}
                        <CardTitle>{activityHeader}</CardTitle>
                    </Caption>
                </Grid>
            </Grid>
            <Grid container className={classes.row}>
                <ActivityQuestionMapper WorkActivitydetails={WorkActivitydetails} />
            </Grid>
        </Card>
    );
};

export default WorkOrderActivity;
